import { useFormik } from "formik"
import * as Yup from "yup"
import React, { useMemo } from "react"
import toast from "react-hot-toast"
import { Button, Form, Modal, ModalBody, ModalHeader } from "reactstrap"
import {
  useCreatePermissionMutation,
  useUpdatePermissionMutation,
} from "store/api/permissions/permissions.api"

const defaultValues = {
  module: "",
  key: "",
  label: "",
}

function CreatePermissionModal({
  open,
  setOpen,
  title,
  onCreateSuccess,
  editData,
}) {
  const [createPermission] = useCreatePermissionMutation()
  const [updatePermission] = useUpdatePermissionMutation()

  const mutate = editData === null ? createPermission : updatePermission

  const initialValues = useMemo(() => {
    if (editData) {
      const { id, ...rest } = editData
      return { ...defaultValues, ...rest }
    } else {
      return { ...defaultValues }
    }
  }, [])

  const onFormSubmit = async (values, resetForm) => {
    try {
      const { message, success } = await mutate(values).unwrap()
      if (success) {
        toast.success(message, { id: "submitSuccess" })
        resetForm()
        onCreateSuccess()
        setOpen(false)
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const onFormUpdate = async (values, resetForm) => {
    try {
      const { data, message, success } = await mutate({
        ...values,
        id: editData?.id,
      }).unwrap()
      if (success) {
        toast.success(message, { id: "editSuccess" })
        resetForm()
        onCreateSuccess()
        setOpen(false)
      }
    } catch (error) {
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: Yup.object({}),
    onSubmit: async (values, { resetForm }) => {
      if (editData === null) {
        await onFormSubmit(values, resetForm)
      } else {
        onFormUpdate(values, resetForm)
      }
    },
  })

  return (
    <Modal
      isOpen={open}
      toggle={() => {
        setOpen((prev) => !prev)
      }}
    >
      <ModalHeader
        toggle={() => {
          setOpen((prev) => !prev)
        }}
      >
        {title} Permission
      </ModalHeader>
      <ModalBody>
        <Form
          onSubmit={(e) => {
            e.preventDefault()
            validation.handleSubmit()
            return false
          }}
        >
          <div className="mb-2">
            <label htmlFor="module" className="col-form-label">
              Module:
            </label>
            <input
              id="module"
              name="module"
              type="text"
              value={validation.values.module || ""}
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              className="form-control"
            />
          </div>
          <div className="mb-2">
            <label htmlFor="key" className="col-form-label">
              Key:
            </label>
            <input
              id="key"
              name="key"
              type="text"
              value={validation.values.key || ""}
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              className="form-control"
            />
          </div>

          <div className="mb-2">
            <label htmlFor="label" className="col-form-label">
              Label:
            </label>
            <input
              id="label"
              name="label"
              type="password"
              className="form-control"
              value={validation.values.label || ""}
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
            />
          </div>
          <Button type="submit" color="primary">
            Submit
          </Button>
        </Form>
      </ModalBody>
    </Modal>
  )
}

export default CreatePermissionModal
